import { render } from "./ai-text-box-readonly.vue?vue&type=template&id=43ea8a62"
import script from "./ai-text-box-readonly.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-text-box-readonly.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-text-box-readonly.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43ea8a62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43ea8a62', __exports__)) {
    api.reload('43ea8a62', __exports__)
  }
  
  module.hot.accept("./ai-text-box-readonly.vue?vue&type=template&id=43ea8a62", () => {
    api.rerender('43ea8a62', render)
  })

}


export default __exports__